var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.5 3.53a.5.5 0 0 0-1 0v7.97H3.53a.5.5 0 1 0 0 1h7.97v7.97a.5.5 0 1 0 1 0V12.5h7.97a.5.5 0 0 0 0-1H12.5z",
    clipRule: "evenodd"
  })));
});
const SvgAdd = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdd);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi40OTk5IDMuNTI5M0MxMi40OTk5IDMuMjUzMTUgMTIuMjc2IDMuMDI5MyAxMS45OTk5IDMuMDI5M0MxMS43MjM3IDMuMDI5MyAxMS40OTk5IDMuMjUzMTUgMTEuNDk5OSAzLjUyOTNWMTEuNDk5OUgzLjUyOTNDMy4yNTMxNSAxMS40OTk5IDMuMDI5MyAxMS43MjM3IDMuMDI5MyAxMS45OTk5QzMuMDI5MyAxMi4yNzYgMy4yNTMxNSAxMi40OTk5IDMuNTI5MyAxMi40OTk5SDExLjQ5OTlWMjAuNDcwNUMxMS40OTk5IDIwLjc0NjYgMTEuNzIzNyAyMC45NzA1IDExLjk5OTkgMjAuOTcwNUMxMi4yNzYgMjAuOTcwNSAxMi40OTk5IDIwLjc0NjYgMTIuNDk5OSAyMC40NzA1VjEyLjQ5OTlIMjAuNDcwNUMyMC43NDY2IDEyLjQ5OTkgMjAuOTcwNSAxMi4yNzYgMjAuOTcwNSAxMS45OTk5QzIwLjk3MDUgMTEuNzIzNyAyMC43NDY2IDExLjQ5OTkgMjAuNDcwNSAxMS40OTk5SDEyLjQ5OTlWMy41MjkzWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";